export default "__VITE_ASSET__D0$ebh_F__"